import type { Period } from "@go-novus/admin-api";

import {
  createResourceQueryAtom,
  defineResource,
  defineResourceQuery,
} from "#/shared/lib/resource";

import { getHomeMetrics } from "../api/get-home-metrics";

const homeMetricsResource = defineResource("home-metrics");

const homeMetricsQuery = defineResourceQuery({
  key: (period: Period) => [period],
  name: "detail",
  queryFn: (period: Period) => getHomeMetrics(period),
  resource: homeMetricsResource,
  // 运营可在另一入口修改归属，已打开页面也需重新读取当前事实。
  refetchInterval: 30_000,
  staleTime: 60_000,
});

function createHomeMetricsAtom(period: Period) {
  return createResourceQueryAtom(homeMetricsQuery, () => period);
}

const atomsByPeriod = new Map<
  Period,
  ReturnType<typeof createHomeMetricsAtom>
>();

/**
 * Home 指标读模型，按周期各缓存一份：切到近 30 天不会顶掉近 7 天的结果，
 * 切回去还能直接命中。周期只有两个值，atom 建了就一直留着；
 * 不用 jotai 的 atomFamily 是因为它已标记废弃，替代品在仓库里没有依赖。
 */
export function homeMetricsAtom(period: Period) {
  const existing = atomsByPeriod.get(period);

  if (existing !== undefined) {
    return existing;
  }

  const created = createHomeMetricsAtom(period);
  atomsByPeriod.set(period, created);

  return created;
}
